class YoutubeLink {
  constructor(url) {
    this.url = new URL(url)
  }

  getVideoId() {
    return this.url.searchParams.get('v')
  }

  getVideoTime() {
    return this.url.searchParams.get('t')
  }
}

export default YoutubeLink
